import React from 'react';
import flatMap from 'lodash/flatMap';
import identity from 'lodash/identity';
import find from 'lodash/find';

import { EMAIL_TEMPLATE_INPUT_ID } from 'xm-constants/flowInput';
import { RESPONSES } from 'xm-constants/messageProperties';
import OfficesIcon from 'resources/svg/icon-offices.svg';
import WebsitesIcon from 'resources/svg/icon-website.svg';

export const messageStaticProperties = {
  recipient: [
    {
      id: 'person.alertContext',
      nameId: 'ALERT_CONTEXT',
      apiId: 'PERSON_ALERT_CONTEXT',
    },
    {
      id: 'person.firstName',
      nameId: 'FIRST_NAME',
      apiId: 'PERSON_FIRST_NAME',
    },
    {
      id: 'person.lastName',
      nameId: 'LAST_NAME',
      apiId: 'PERSON_LAST_NAME',
    },
    {
      id: 'person.webLogin',
      nameId: 'WEB_LOGIN_ID',
      apiId: 'PERSON_WEB_LOGIN',
    },
  ],
  sender: [
    {
      id: 'sender.firstName',
      nameId: 'FIRST_NAME',
      apiId: 'SENDER_FIRST_NAME',
    },
    {
      id: 'sender.lastName',
      nameId: 'LAST_NAME',
      apiId: 'SENDER_LAST_NAME',
    },
  ],
  alertDetails: [
    {
      id: 'alert.alertID',
      nameId: 'ALERT_ID',
      apiId: 'EVENT_EVENT_ID',
    },
    {
      id: 'alert.startDate',
      nameId: 'START_DATE',
      apiId: 'EVENT_START_DATE',
    },
    {
      id: 'alert.startTime',
      nameId: 'START_TIME',
      apiId: 'EVENT_START_TIME',
    },
  ],
  company: [
    {
      id: 'other.companyName',
      nameId: 'NAME_C',
      apiId: 'COMPANY_NAME',
      icon: <OfficesIcon />,
    },
    {
      id: 'other.companyUrl',
      nameId: 'XMATTERS_URL',
      apiId: 'COMPANY_URL',
      icon: <WebsitesIcon />,
    },
  ],
  responses: [
    {
      id: RESPONSES,
      nameId: 'VARIABLE_KEY_RESPONSE',
      apiId: 'RESPONSES',
    },
  ],
};

const allMessageStaticProperties = flatMap(
  Object.values(messageStaticProperties),
  identity,
);

export const getMessageStaticPropertiesIds = ({ inputId }) => {
  let relevantProperties = allMessageStaticProperties;
  if (inputId !== EMAIL_TEMPLATE_INPUT_ID) {
    relevantProperties = relevantProperties.filter(
      prop => prop.id !== RESPONSES,
    );
  }
  return relevantProperties.map(entry => entry.id);
};

export const getMessageStaticPropById = id =>
  find(allMessageStaticProperties, { id });
